import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, FilterPipe, MAT_ICON, TOAST_STATE, ToastmessageService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { GetProductsResponse } from '../../products/product-list/get-products.response';
import { Material } from '../../products/product-list/material.model';
import { AddProductToSerieRequest } from '../addproductstoserie/addproducttoserierequest';
import { AddProductToSerieResponse } from '../addproductstoserie/addproducttoserieresponse';
import { Serie } from '../serie';
import { AddSerieRequest } from './addserierequest';
import { BookWithSerienumber } from './bookwithserienumber';
import { SelectedProduct } from './selectedproduct';

@Component({
    selector: 'app-addserie',
    templateUrl: './addserie.component.html',
    styleUrls: ['./addserie.component.scss'],
    standalone: true,
    imports: [MatIconModule, FilterPipe, FormsModule, ReactiveFormsModule, DragDropModule, CommonModule, RouterModule, TranslationPipe]
})
export class AddserieComponent implements OnInit {
    addProductToSerieRequest: AddProductToSerieRequest = {};

    addProductToSerieResponse: AddProductToSerieResponse = {};

    addSerieRequest: AddSerieRequest = {};

    addSerieUrl = '/admin/addserie';

    displayAddProductToSerie = false;

    filteredBooks: Material[] = [];

    filteredProduct: Material[] = [];

    getProductsUrl = '/store/get-products';

    products: Material[] = [];

    productsToSerie: Material[] = [];

    routerLink = '';

    searchText = '';

    selectedBook: Material = {};

    selectedBookList: BookWithSerienumber[] = [];

    selectedProductList?: SelectedProduct[] = [];

    serie: Serie = {};

    serieForm?: FormGroup;

    serieNumber = 0;

    serieNumberForm?: FormGroup;

    serieNumberToAdd = 0;

    size = 1;

    storeBaseUrl = '';

    private _listFilter = '';

    get listFilter(): string {
        return this._listFilter;
    }

    set listFilter(value: string) {
        this._listFilter = value;
        this.filteredProduct = this.performFilter(value);
    }

    constructor(
        private _router: Router,
        private _fb: FormBuilder,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _toastMessageService: ToastmessageService,
        private _translateService: TranslationService
    ) {
        this.storeBaseUrl = _storeBaseUrl;
        this.createSerieForm();
        this.createSerieNumberForm();
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            this._apiRequestService.sendRequest(this.storeBaseUrl, {}, true, this.getProductsUrl).subscribe((response) => {
                const products = response as GetProductsResponse;
                this.products = products.productList as Material[];
                this.filteredBooks = this.products;
            });
        } else {
            this._router.navigateByUrl('/');
        }
    }

    performFilter(filterBy: string): Material[] {
        filterBy = filterBy.toLocaleLowerCase();
        return this.products.filter(
            (publication: Material) =>
                publication.title?.toLocaleLowerCase().includes(filterBy) ||
                publication.author?.toLocaleLowerCase().includes(filterBy) ||
                publication.title?.toLocaleLowerCase().includes(filterBy)
        );
    }

    createSerieForm() {
        this.serieForm = this._fb.group({
            serieName: ['', [Validators.required]]
        });
    }

    createSerieNumberForm() {
        this.serieNumberForm = this._fb.group({
            serieNumber: ['', [Validators.required]]
        });
    }

    collectSerieData() {
        this.serie = {
            serieName: this.serieForm?.controls['serieName'].value as string | undefined
        };
    }

    collectSerieNumber() {
        this.serieNumber = this.serieNumberForm?.controls['serieNumber'].value as number;
    }

    addSerie() {
        if (this.selectedBookList.length === 0) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('Kérem adjon hozzá könyvet/könyveket a sorozathoz! '),
                MAT_ICON.error
            );
            this.dismissError();
            return;
        } else if (!this.serieForm?.controls['serieName'].value) {
            this._toastMessageService.displayToastMessage(
                TOAST_STATE.error,
                this._translateService.translate('Kérem adja meg a sorozat nevét! '),
                MAT_ICON.error
            );
            this.dismissError();
            return;
        }

        this._apiRequestService
            .sendRequest<AddSerieRequest, HttpResponse<any>>(this.storeBaseUrl, this.createAddSerieRequest(), true, this.addSerieUrl, true)
            .subscribe(() => {
                this._router.navigateByUrl('/series');
            });
    }

    private dismissError(): void {
        setTimeout(() => {
            this._toastMessageService.dismissToast();
        }, 3000);
    }

    drop(event: CdkDragDrop<BookWithSerienumber[]>) {
        moveItemInArray(this.selectedBookList, event.previousIndex, event.currentIndex);
    }

    addProduct(product: Material) {
        this.serieNumberToAdd = this.serieNumberToAdd + 1;
        const bookWithSeriNumber: BookWithSerienumber = {
            book: product,
            serieNumber: this.serieNumberToAdd
        };
        const index = this.products.indexOf(product);
        this.products.splice(index, 1);
        this.selectedBookList.push(bookWithSeriNumber);
    }

    deleteFromSerie(selectedBookList: BookWithSerienumber) {
        const index = this.selectedBookList.indexOf(selectedBookList);
        this.selectedBookList.splice(index, 1);
        this.products.push(selectedBookList.book!);
    }

    move(from: number, to: number, selectedBook: BookWithSerienumber[]): BookWithSerienumber[] {
        const newArr = [...selectedBook];

        const item = newArr.splice(from, 1)[0];
        newArr.splice(to, 0, item);

        return newArr;
    }

    createAddSerieRequest(): AddSerieRequest {
        this.collectSerieData();
        const selectedProductList: SelectedProduct[] = this.selectedBookList.map((selectedBook, index) => ({
            productId: selectedBook.book?.id,
            serieNumber: index + 1
        }));

        const addSerieRequest: AddSerieRequest = {
            serie: this.serie,
            selectedProductList: selectedProductList
        };

        return addSerieRequest;
    }
}
